import { UploadProvider } from '@components/Files/UploadProvider';
import { S3SignedUrlUploader } from '@components/Files/UploadProvider/providers/S3SignedUrlUploader';
import { useAPI } from '@providers/useAPI';
import { BulkCreateJobsModalContent } from './content';
import { ModalProvider } from './providers/ModalProvider';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
};

export const BulkCreateJobsModal = ({ onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  return (
    <UploadProvider
      config={{
        mode: 'deferred',
        uploader: S3SignedUrlUploader(call),
      }}
    >
      <ModalProvider onCancel={onCancel} onSuccess={onSuccess}>
        <ModalWrapper width="500px">
          <ModalTitle>Bulk Job Creation</ModalTitle>
          <Content>
            <BulkCreateJobsModalContent />
          </Content>
        </ModalWrapper>
      </ModalProvider>
    </UploadProvider>
  );
};
